/* eslint-disable @typescript-eslint/camelcase */
// more plugins can be found here https://www.tiny.cloud/docs/plugins/
export const PLUGIN_LIST = [
	// "advlist",
	"anchor",
	"autolink",
	// "charmap",
	"code",
	// "fullscreen",
	// "help",
	"hr",
	// "image",
	// "insertdatetime",
	"link",
	"lists",
	// "media",
	// "paste",
	// "preview",
	// "print",
	// "searchreplace",
	// "spellchecker",
	// "table",
	// "visualblocks",
	// "wordcount",
];

// more toolbar controls can be found here https://www.tiny.cloud/docs/advanced/editor-control-identifiers/#toolbarcontrols
export const TOOLBAR = [
	"bold italic underline | styleselect | forecolor | alignleft aligncenter alignright | bullist numlist | link | hr | code | removeformat",
];

// HTML element selectors - CSS3 style
export const selector = "p,h1,h2,h3,h4,h5,h6,div,ul,ol,li";

export const validElements = [
	"b[class|style]",
	"b/strong",
	"i[class|style]",
	"i/em",
	"em[class|style]",
	"u[class|style]",
	"br",
	"p[class|style]",
	"div[class|style]",
	"span[class|style]",
	"ul[class|style]",
	"u[class|style]",
	"ol[class|style]",
	"li[class|style]",
	"hr[class|style]",
	"var",
	"img[alt|src|style|width|height|class]",
	"iframe[src|style|frameborder|allowfullscreen|width|height]",
	"a[href|target]",
];

export const defaultConfig = {
	height: 200,
	menubar: false,
	statusbar: false,

	plugins: PLUGIN_LIST,
	toolbar: TOOLBAR,
	forecolor: { inline: "span" },
	custom_colors: true,
	forced_root_block: false,
	relative_urls: false,
	remove_script_host: false,

	formats: {
		bold: { inline: "b", exact: true },
		underline: { inline: "u", exact: true },
		italic: { inline: "i", exact: true },

		alignleft: {
			selector,
			classes: "wysiwyg-text-align-left",
		},
		aligncenter: {
			selector,
			classes: "wysiwyg-text-align-center",
		},
		alignright: {
			selector,
			classes: "wysiwyg-text-align-right",
		},
		alignfull: {
			selector,
			classes: "wysiwyg-text-align-justify",
		},
	},
	style_formats: [
		{ title: "X-Small", inline: "span", classes: "wysiwyg-font-size-x-small" },
		{ title: "Small", inline: "span", classes: "wysiwyg-font-size-small" },
		{ title: "Default", inline: "span", classes: "wysiwyg-font-size-default" },
		{ title: "Large", inline: "span", classes: "wysiwyg-font-size-large" },
		{ title: "X-Large", inline: "span", classes: "wysiwyg-font-size-x-large" },
		{ title: "XX-Large", inline: "span", classes: "wysiwyg-font-size-xx-large" },
	],
	content_style:
		".wysiwyg-text-align-left {text-align: left} .wysiwyg-text-align-center img {margin: auto} .wysiwyg-text-align-center {text-align: center} .wysiwyg-text-align-right  {text-align: right} .wysiwyg-font-size-x-small {font-size: 50%} .wysiwyg-font-size-small {font-size: 75%}  .wysiwyg-font-size-default {font-size: 100%} .wysiwyg-font-size-large {font-size: 150%} .wysiwyg-font-size-x-large {font-size: 200%} .wysiwyg-font-size-xx-large {font-size: 300%} .wysiwyg-color-default {color: #444444} .wysiwyg-color-blue {color: blue} .wysiwyg-color-brown {color: brown} .wysiwyg-color-cyan {color: cyan} .wysiwyg-color-green {color: green} .wysiwyg-color-magenta {color: magenta} .wysiwyg-color-orange {color: #e25d25} .wysiwyg-color-purple {color: purple} .wysiwyg-color-red {color: red} .wysiwyg-color-yellow { color: yellow }",

	// allowable tags for the editor... in this case, allowing the bold / underline / italic buttons insert <b> <u> <i>
	valid_elements: validElements.join(","),
};
